<div class="grid">
  <mat-card appearance="outlined" class="first">

    <h3>Processing Documents</h3>

    <mat-card-content>
      @if (!processing.length) {
        <div>
          @if (!isDoneProcessingScans) {
            <div class="empty"
              >
              <mat-icon>cloud_circle</mat-icon>
              <br>
                <span>Documents are processing.</span>
              </div>
            }
            @else {
              <div class="empty"
                >
                <mat-icon>done_all</mat-icon>
                <br>
                  <span>Documents were processed!</span>
                </div>
              }
            </div>
          }

          <mat-list role="list">
            @for (result of processing; track $index) {
              <mat-list-item role="listitem">
                <mat-icon matListItemIcon color="primary">cached</mat-icon>
                <div matListItemLine>{{result.sortKey.split('-')[1]}}</div>
              </mat-list-item>
            }
          </mat-list>
        </mat-card-content>
      </mat-card>

      <mat-card appearance="outlined">

        <h3>Successful Documents</h3>

        <mat-card-content>
          @if (!successful.length) {
            <div>
              @if (!isDoneProcessingScans) {
                <div class="empty"
                  >
                  <mat-icon>cloud_circle</mat-icon>
                  <br>
                    <span>Documents are processing.</span>
                  </div>
                }
                @else {
                  <div class="empty"
                    >
                    <mat-icon>thumb_down</mat-icon>
                    <br>
                      <span>Documents were unsuccessful!</span>
                    </div>
                  }
                </div>
              }
              <mat-list role="list">
                @for (result of successful; track $index) {
                  <mat-list-item role="listitem">
                    <mat-icon matListItemIcon color="primary">check_circle</mat-icon>
                    <div matListItemLine>{{result.sortKey.split('-')[1]}}</div>
                  </mat-list-item>
                }
              </mat-list>
            </mat-card-content>
          </mat-card>

          <mat-card appearance="outlined">
            <h3>Failed Documents</h3>

            <mat-card-content>
              @if (!failures.length) {
                <div>
                  @if (!isDoneProcessingScans) {
                    <div class="empty"
                      >
                      <mat-icon>cloud_circle</mat-icon>
                      <br>
                        <span>Documents are processing.</span>
                      </div>
                    }
                    @if (isDoneProcessingScans) {
                      <div class="empty"
                        >
                        <mat-icon>thumb_up</mat-icon>
                        <br>
                          <span>Documents were successful!</span>
                        </div>
                      }
                    </div>
                  }

                  <mat-list role="list">
                    @for (result of failures; track $index) {
                      <mat-list-item role="listitem">
                        @if (result.error) {
                          <mat-icon matListItemIcon color="warn">info</mat-icon>
                        }
                        <div matListItemLine>{{result.sortKey.split('-')[1]}}</div>
                      </mat-list-item>
                    }
                  </mat-list>
                </mat-card-content>
              </mat-card>
            </div>
